<template>
    <div class="block max-w-4xl">
        <label>
            <span class="text-gray-700 dark:text-gray-200">{{ label }}</span>
        </label>
        <div class="block">
            <vue-timepicker
                input-class="block w-full bg-white dark:bg-gray-700 text-black dark:text-white rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 mt-1 disabled:opacity-50"
                :disabled="disabled"
                :name="name"
                :format="format"
                :monday-first="true"
                :value="value"
                @input="handler"
                :clear-button="true"
                close-on-complete
            />
        </div>
        <error :error="error" />
    </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
    name: "InputDate",
    components: {
        VueTimepicker
    },
    props: {
        name: String,
        label: String,
        format: {
            type: String,
            required: false,
            default: 'HH:mm',
        },
        value: {
            type: String,
            required: false,
            default: '',
        },
        error: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false
        },
    },
    methods: {
        handler: function(time) {
            if (typeof time !== "string") {
                time = `${time.HH}:${time.mm}`;
            }
            this.$emit('input', time);
        },
    },
};
</script>
